import { useMutation } from 'react-query'

// Services
import { GetDocuments } from 'services/api/Ai'

export default () => {
  const {
    mutate: getDocuments,
    data: getDocumentsData,
    error: getDocumentsError,
    isLoading: isGetDocumentsLoading,
    isSuccess: isGetDocumentsSuccess,
    isError: isGetDocumentsError,
  } = useMutation(GetDocuments)

  return {
    getDocuments,
    getDocumentsData,
    getDocumentsError,
    isGetDocumentsLoading,
    isGetDocumentsSuccess,
    isGetDocumentsError,
  }
}
